export default "__VITE_ASSET__DYza6R$S__"